import React, { Component, useEffect, useState } from "react";
import ComponentEditProfileMobile from "./ComponentEditProfileMobile";
import ComponentEditProfileWeb from "./ComponentEditProfileWeb";
import { BrowserView, MobileView } from "react-device-detect";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from "react-ga4";
const ComponentEditProfile = () => {
  const gaEventTracker = useAnalyticsEventTracker("EditProfile");
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Edit Profile",
    });
  }, []);
  return (
    <>
      <BrowserView>
        <ComponentEditProfileWeb></ComponentEditProfileWeb>
      </BrowserView>
      <MobileView>
        <ComponentEditProfileMobile></ComponentEditProfileMobile>
      </MobileView>
    </>
  );
};

export default ComponentEditProfile;
